import { useEffect, useState, useMemo } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import Icon from "@mui/material/Icon";
import {
  Grid,
  InputAdornment,
  Box,
  Typography,
  Avatar,
  Autocomplete,
  TextField,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import axios from "axios";
import BASE_URL from "config/Base_URL";
import MyModal from "components/Modal"; // Pastikan path sesuai
import Swal from "sweetalert2";

const DataTableProduk = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [listAccount, setListAccount] = useState([]);
  const token = sessionStorage.getItem("token");

  const [idUser, setIdUser] = useState("");
  const [name, setName] = useState("");
  const [businessName, setBussinessName] = useState("");
  const [username, setUsername] = useState("");
  const [noHp, setNoHp] = useState("");
  const [gambar, setGambar] = useState("");
  const [address, setAddress] = useState("");
  const [role, setRole] = useState("");

  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDetailShow, setModalDetailShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);

  // ================================================================
  //                                 DELETE
  // ================================================================

  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${BASE_URL}/user/delete/${idUser}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setModalDeleteShow(false);
      Swal.fire("Berhasil", "User berhasil dihapus", "success");
      fetchUsers();
    } catch (error) {
      console.log(error);
      setModalDeleteShow(false);
      Swal.fire("Gagal", "User gagal dihapus", "error");
    }
  };

  // ================================================================
  //                                 EDIT
  // ================================================================

  const handleEdit = (item) => {
    setIdUser(item.id);
    setName(item.name);
    setBussinessName(item.businessName);
    setNoHp(item.noHp);
    setGambar(item.picture);
    setAddress(item.address);
    setRole(item.role);
    setModalEditShow(true);
  };

  function base64ToFile(base64String, fileName = "image.jpg") {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  }

  const handleSubmitEdit = async () => {
    try {
      const formDataEdit = new FormData();

      formDataEdit.append("id", idUser);
      formDataEdit.append("name", name);
      formDataEdit.append("businessName", businessName);
      formDataEdit.append("noHp", noHp);
      formDataEdit.append("address", address);

      if (typeof gambar === "string" && gambar.length > 100) {
        let base64 = gambar;
        if (!gambar.startsWith("data:image")) {
          // Asumsikan itu adalah image/jpeg
          base64 = "data:image/jpeg;base64," + gambar;
        }

        const response = await fetch(base64);
        const blob = await response.blob();
        const file = new File([blob], "image.jpg", { type: blob.type });
        formDataEdit.append("picture", file);
      }

      // Debug isi formData (opsional)
      for (let [key, value] of formDataEdit.entries()) {
        console.log(`${key}:`, value);
      }

      // Kirim request
      const response = await axios.put(`${BASE_URL}/update/user/${idUser}`, formDataEdit, {
        headers: {
          Authorization: `Bearer ${token}`, // Sesuaikan dengan skema autentikasi Anda
          "Content-Type": "multipart/form-data",
        },
      });
      setModalEditShow(false);
      fetchUsers();
      Swal.fire("Berhasil", "Data user berhasil diperbarui!", "success");
    } catch (error) {
      setModalEditShow(false);
      console.error("Error saat update user:", error);
      Swal.fire("Gagal", "Gagal memperbarui data user!", "error");
    }
  };

  const roles = ["admin", "user"];

  const renderForm = (
    <Grid container spacing={2} maxWidth="lg">
      {/* Gambar Produk (opsional) */}
      <Grid item xs={12}>
        <MDBox mb={2}>
          <Typography variant="body2" gutterBottom>
            Gambar Produk (opsional)
          </Typography>

          {gambar ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
              <Avatar
                src={
                  typeof gambar === "string"
                    ? gambar.startsWith("data:image")
                      ? gambar
                      : `data:image/png;base64,${gambar}`
                    : URL.createObjectURL(gambar)
                }
                variant="rounded"
                sx={{ width: 250, height: 250 }}
              />
              <MDButton variant="outlined" color="error" onClick={() => setGambar(null)}>
                Hapus Gambar
              </MDButton>
            </Box>
          ) : (
            <MDButton
              component="label"
              variant="outlined"
              color="secondary"
              fullWidth
              startIcon={<CloudUpload />}
            >
              Pilih Gambar
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => setGambar(e.target.files[0])}
              />
            </MDButton>
          )}
          <Typography variant="caption" display="block" mt={1}>
            Format: JPG, PNG (Maks. 5MB)
          </Typography>
        </MDBox>
      </Grid>

      {/* Nama User */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            size="xxl"
            label="Nama Lengkap"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Nama Usaha */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="Nama Usaha"
            variant="outlined"
            value={businessName}
            onChange={(e) => setBussinessName(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Role */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <Autocomplete
            fullWidth
            options={roles}
            value={role}
            onChange={(event, newValue) => setRole(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Role"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </MDBox>
      </Grid>

      {/* No Hp */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="No Hp"
            variant="outlined"
            value={noHp}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setNoHp(value);
              }
            }}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="Alamat"
            variant="outlined"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            InputLabelProps={{ shrink: true }}
            multiline
            rows={3}
            sx={{
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
              },
              "& textarea": {
                resize: "vertical",
                minHeight: "80px",
              },
            }}
          />
          <Typography variant="caption" color="textSecondary">
            Maksimal 500 karakter • {(address || "").length}/500
          </Typography>
        </MDBox>
      </Grid>
    </Grid>
  );

  // ==================================================================
  //                               GET USER
  // ==================================================================

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setListAccount(response.data.data);
    } catch (error) {
      console.error("Gagal menampilkan user:", error);
    }
  };

  // ===================================================================
  //                                DETAIL
  // ===================================================================

  const handleDetail = async (item) => {
    try {
      const response = await axios.get(`${BASE_URL}/users/${item.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const userResponse = response.data.data;
      setIdUser(userResponse.id);
      setName(userResponse.name);
      setBussinessName(userResponse.businessName);
      setUsername(userResponse.username);
      setGambar(userResponse.picture);
      setNoHp(userResponse.noHp);
      setAddress(userResponse.address);
      setRole(userResponse.role);

      setModalDetailShow(true);
    } catch (error) {
      console.log(error);
      Swal.fire("Gagal", "Gagal mengambil data user!", "error");
    }
  };

  const renderFormDetail = (
    <Grid container spacing={2} maxWidth="lg">
      <Grid item xs={12}>
        <MDBox mb={2}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
            <Avatar
              src={
                typeof gambar === "string"
                  ? gambar.startsWith("data:image")
                    ? gambar
                    : `data:image/png;base64,${gambar}`
                  : ""
              }
              variant="rounded"
              sx={{ width: 200, height: 200 }}
            />
          </Box>
        </MDBox>
      </Grid>

      {/* Nama User */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            size="xxl"
            label="Nama User"
            variant="outlined"
            value={name}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Nama Usaha */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            disabled
            fullWidth
            label="Nama Usaha"
            variant="outlined"
            value={businessName}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Username */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            disabled
            fullWidth
            label="Username"
            variant="outlined"
            value={username}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Role */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            disabled
            fullWidth
            label="Role"
            variant="outlined"
            value={role}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* No Hp */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            disabled
            fullWidth
            label="No Hp"
            variant="outlined"
            value={noHp}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* alamat */}
      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            disabled
            fullWidth
            label="Alamat"
            variant="outlined"
            value={address}
            InputLabelProps={{ shrink: true }}
            multiline
            rows={3}
            sx={{
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
              },
              "& textarea": {
                resize: "vertical",
                minHeight: "80px",
              },
            }}
          />
          <Typography variant="caption" color="textSecondary">
            Maksimal 500 karakter • {(address || "").length}/500
          </Typography>
        </MDBox>
      </Grid>
    </Grid>
  );

  const columns = useMemo(
    () => [
      { Header: "No", accessor: "no", width: "5%", align: "left" },
      { Header: "Nama", accessor: "nama", align: "left" },
      { Header: "Nama Usaha", accessor: "nama_usaha", align: "center" },
      { Header: "Username", accessor: "username", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],
    []
  );

  const rows = useMemo(
    () =>
      listAccount.map((item, index) => ({
        no: index + 1,
        nama: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.name}
          </MDTypography>
        ),
        nama_usaha: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.businessName}
          </MDTypography>
        ),
        username: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.username}
          </MDTypography>
        ),
        action: (
          <MDBox display="flex" alignItems="center" justifyContent="center">
            <MDBox mr={1}>
              <MDButton
                variant="text"
                color="error"
                onClick={() => {
                  setModalDeleteShow(true);
                  setIdUser(item.id);
                }}
              >
                <Icon>delete</Icon>&nbsp;delete
              </MDButton>
            </MDBox>
            <MDBox mr={1}>
              <MDButton variant="text" color="success" onClick={() => handleEdit(item)}>
                <Icon>edit</Icon>&nbsp;edit
              </MDButton>
            </MDBox>
            <MDButton variant="text" color="info" onClick={() => handleDetail(item)}>
              <Icon>priority_high</Icon>&nbsp;detail
            </MDButton>
          </MDBox>
        ),
      })),
    [listAccount, darkMode]
  );

  const modalEdit = (
    <MyModal
      show={modalEditShow}
      onHide={() => setModalEditShow(false)}
      title="Edit User"
      body={renderForm}
      onSubmit={handleSubmitEdit}
      submitText="Simpan"
      colorButtonSubmit="info"
    />
  );

  const modalDetail = (
    <MyModal
      show={modalDetailShow}
      onHide={() => setModalDetailShow(false)}
      title="Detail User"
      body={renderFormDetail}
    />
  );

  const modalDelete = (
    <MyModal
      show={modalDeleteShow}
      submitText="Hapus"
      variant="danger"
      onSubmit={handleDelete}
      onHide={() => setModalDeleteShow(false)}
      colorButtonSubmit="primary"
      body="Apakah anda yakin ingin menghapus data ini?"
    />
  );

  return { columns, rows, modalEdit, modalDetail, modalDelete };
};

export default DataTableProduk;
